/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The possible component output json schema drafts.
 * @export
 */
export type ComponentOutputJsonSchemaDraft = ComponentOutputJsonSchemaDraft07;

/**
 * The json output schema draft-07 type.
 * @export
 */
export type ComponentOutputJsonSchemaDraft07 = typeof COMPONENT_OUTPUT_JSON_SCHEMA_DRAFT_07;

/**
 * The json output schema draft-07 constant.
 * @export
 */
export const COMPONENT_OUTPUT_JSON_SCHEMA_DRAFT_07 = 'http://json-schema.org/draft-07/schema#';
